import React from 'react'

function Blog() {
  return (
    <div className='ml-[300px]'>
      Blog
    </div>
  )
}

export default Blog
